import React from "react";
import { useTranslation } from "react-i18next";

const Rights = () => {
  const { t } = useTranslation();

  return <p className="pt-3 text-center text-sm text-textNormal">{t("all_rights_reserved")}</p>;
};

export default Rights;
